import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../constants/path';
import { CONTEXT_ROOT } from '../../constants';

import { scrollToAnchor } from '../../utils';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import HeadComponent from '../HeadComponent';
import Breadcrumb from '../breadcrumb/Breadcrumb';
import { withTemplate } from '../template/withTemplate';
import { PrimaryTemplate } from '../template/PrimaryTemplate';

import './LegalNoticePage.scss';

class LegalNoticePage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;
        return (
            <main role="main" className="conteneur conteneur-mobile" id="p-mentionslegales">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.LEGAL_NOTICE_PATH}`}
                />
                <Breadcrumb
                    defaultRoute
                    routes={[
                        {
                            label: i18n.BREADCRUMB,
                            route: PATH.LEGAL_NOTICE_PATH
                        }
                    ]}
                />
                <h1>
                    {i18n.TITLE}
                    <br />
                    {i18n.SUBTITLE}
                </h1>

                <h2>{i18n.TITLE0}</h2>

                <h3>{i18n.TITLE1}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_1)}</p>
                <div className="clicktocall-wrapper">
                    <div className="clicktocall">
                        <p className="clicktocall-horizontal">
                            <a className="purple" href="tel:3639">
                                {i18n.ACERP_1}
                            </a>
                            <span className="text purple">
                                <span>{i18n.ACERP_2}</span>
                            </span>
                        </p>
                    </div>
                    <div className="clicktocall">
                        <p className="clicktocall-horizontal">
                            <a className="grey" href="tel:0969399998">
                                {convertHtmlToReactDomWithParams(i18n.ACERP_3)}
                            </a>
                            <span className="text grey">
                                <span>{i18n.ACERP_4}</span>
                            </span>
                        </p>
                    </div>
                </div>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_2)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_3)}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>{i18n.TEXT2_1}</p>

                <h3>{i18n.TITLE3}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_1)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_2)}</p>
            </main>
        );
    }
}

LegalNoticePage.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.LEGAL_NOTICE
    };
}

export default withTemplate(connect(mapStateToProps)(LegalNoticePage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/LegalNoticePage.js